import { NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnimateHeightDirective } from '@app/shared/directives/animate-height.directive';

import { AccordionComponent } from '@app/shared/modules/accordion/components/accordion.component';
import { AccordionCollapsedContentDirective } from '@app/shared/modules/accordion/directives/accordion-collapsed-content.directive';
import { AccordionExpandedContentDirective } from '@app/shared/modules/accordion/directives/accordion-expanded-content.directive';
import { AccordionGroupDirective } from '@app/shared/modules/accordion/directives/accordion-group.directive';
import { AccordionHeaderDirective } from '@app/shared/modules/accordion/directives/accordion-header.directive';
import { AccordionToggleDirective } from '@app/shared/modules/accordion/directives/accordion-toggle.directive';

@NgModule({
  declarations: [
    AccordionComponent,
    AccordionGroupDirective,
    AccordionHeaderDirective,
    AccordionToggleDirective,
    AccordionExpandedContentDirective,
    AccordionCollapsedContentDirective,
  ],
  exports: [
    AccordionComponent,
    AccordionGroupDirective,
    AccordionHeaderDirective,
    AccordionToggleDirective,
    AccordionExpandedContentDirective,
    AccordionCollapsedContentDirective,
  ],
  imports: [NgTemplateOutlet, AnimateHeightDirective],
})
export class AccordionModule {}
